module.exports = {"LoadMessages":["Descomplicando sua rotina...","Contando os segundos...","Acertando os ponteiros pra você."]}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/Loader/data.json
// module id = 1667
// module chunks = 0